import { StringCase } from './case';

const convertKeys = (data: unknown, caseFunction: (key: string) => string): unknown => {
    const isArray = Array.isArray(data);
    const isObject = data !== null && typeof data === 'object' && !(data instanceof FormData);

    if(isArray) {
        return data.map((item) => convertKeys(item, caseFunction));
    }

    if(isObject) {
        return Object.keys(data).reduce(
            // @ts-expect-error Type string is not assignable to type never
            (result, key: keyof typeof data) => ({
                ...result,
                [caseFunction(key)]: convertKeys(data[key], caseFunction)
            }),
            {}
        );
    }

    return data;
};

export const convertKeysToCamel = (data: unknown) => convertKeys(data, StringCase.toCamelCase);

export const convertKeysToSnake = (data: unknown) => convertKeys(data, StringCase.toSnakeCase);
